// src/utils/eventUtils.ts
import { FullEvent } from "../shared/FullEvent";
import { normalizeEventLanguage } from "../constants/languages";

export const getDescriptionByLanguage = (event: FullEvent, lang: string) =>
  event.event_descriptions?.find(
    (d) => normalizeEventLanguage(d.language_code) === normalizeEventLanguage(lang)
  );